module.exports = __webpack_public_path__ + "static/tt-desktop-01c90fdcd05f9d73d5317331998891d2.png";